/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import {HISTORY, SessionScope, Solution} from '@exc/core/src/models/Solution';

const starter: Solution = {
  appId: 'starter',
  distributionList: ['Grp-TrojanRabbit'],
  path: '/sample',
  redirectFrom: [{path: '/starter'}],
  spaAppId: 'exc-unified-shell-starter',
  analytics: {
    code: 'sample',
    scripts: {
      dev: 'https://exc-unifiedcontent.experience-stage.adobe.net/static/launch/a7d65461e54e/41e7957f6394/launch-6d30a1f270ca-staging.min.js',
      qa: 'https://exc-unifiedcontent.experience-stage.adobe.net/static/launch/a7d65461e54e/41e7957f6394/launch-6d30a1f270ca-staging.min.js',
      stage: 'https://exc-unifiedcontent.experience-stage.adobe.net/static/launch/a7d65461e54e/41e7957f6394/launch-6d30a1f270ca-staging.min.js',
      prod: 'https://exc-unifiedcontent.experience.adobe.net/static/launch/a7d65461e54e/41e7957f6394/launch-94b41d1729c6.min.js'
    }
  },
  sandbox: {
    history: HISTORY.HISTORY,
    sources: {
      dev: 'https://localhost.corp.adobe.com:12399'
    }
  },
  session: {
    defaultTTL: 7200, // 2 hours
    scope: SessionScope.CONTEXT
  },
  urlContext: {key: 'sandbox', optional: true}
};

export default starter;
